module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "userModule"
  }, [_c('div', {
    staticClass: "userMenu"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("个人中心")]), _vm._v(" "), _c('ul', {
    staticClass: "account-nav"
  }, _vm._l((_vm.nav), function(item, i) {
    return _c('li', {
      key: i,
      class: {
        current: item.name === _vm.title
      },
      on: {
        "click": function($event) {
          return _vm.tab(item)
        }
      }
    }, [_vm._v(_vm._s(item.name))])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "userContent"
  }, [_c('router-view')], 1), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }, [_vm._v(" ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-51e8f8f8","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/user/index.vue
// module id = 763
// module chunks = 2